import React from 'react';
import {connect} from 'react-redux'
import {loadPapers} from "./redux/actions";
import Button from "react-bootstrap/lib/Button";
import {tabNames} from "./constants"
import AddSessionModal from "./components/modals/AddSessionModal";
import Paper from "./components/Paper";
import PaperSession from "./components/PaperSession";
import {filterSessions, isPaperSession} from "./commons";
import {DeleteModal} from "./components/modals/DeleteModal";
import {Loader} from "./components/Loader";
import {deleteSession, getUnassignedPapers} from "./api";
import "./SessionsPage.css"
import EditSessionModal from "./components/modals/EditSessionModal";

class LeftFrame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterText: ''
        };

        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Filter papers according to filterText value
     * @param filterText
     * @param papers
     */
    filterPapers(filterText, papers) {
        const text = filterText.toLowerCase().trim();

        /* Here is where the filtering is done based on the user input */
        return Object.values(papers).filter((paper) => {
            if (text.trim() === '') return true;

            let kws_in_paper = '';
            for (let kw of paper.keywords) kws_in_paper += kw.code.toLowerCase() + ' ';

            return paper.external_id.toString().startsWith(text) || kws_in_paper.includes(text) || paper.track.name.toLowerCase().startsWith(text);
        });
    }

    handleChange(event) {
        const value = event.target.value;

        this.setState((state, props) => {
            return {filterText: value};
        });
    }

    render() {
        const papers = this.filterPapers(this.state.filterText, this.props.papers);

        const paperList =
            Object.values(papers).map((paper) =>
                <Paper key={paper.id}
                       isInSession={false}
                       paper={paper} />
            );

        return (
            <div id="left">
                <div className="filter">
                    <h4>Papers</h4>
                    <input type="text"
                           value={this.state.filterText}
                           onChange={this.handleChange}
                           className="form-control"
                           placeholder="Filter by id, keyword or track"/>
                </div>
                {/*-----LEFT ALLBLOCKS SECTION -----*/}
                <div id="allblocks" className="scrollable">
                    <div id="dragZone" className="dragzone">
                        <div id="dragfrom" className="container-fluid paperstodrag">
                            {paperList}
                        </div>
                    </div>
                </div>
                {/*-- allblocks end -->*/}
            </div>
        )
    }
}

class RightFrame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterText: '',         // Where to store search input
            showModal: {
                Add: false,
                Edit: false,
                Delete: false
            },       // Controls whether to show Session Modal
            editSessionId: null,    // Id of the paper session to edit
            expandPapers: this.initExpandPapers()   // Controls whether to expand or collapse paper summary. Object like {<session_id>: <boolean>}
        };

        /* Event callbacks */
        this.handleChange = this.handleChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.togglePaperSummary = this.togglePaperSummary.bind(this);
        this.toggleAllPaperSummaries = this.toggleAllPaperSummaries.bind(this);
        this.createEntryInExpandPapers = this.createEntryInExpandPapers.bind(this);
        this.removeSession = this.removeSession.bind(this);
    }

    initExpandPapers() {
        const expandPapers = {};
        for (const session_id in this.props.sessions) expandPapers[session_id] = true;
        return expandPapers
    }

    handleChange(event) {
        const value = event.target.value;

        this.setState((state, props) => {
            return {filterText: value}
        });
    }

    handleShow(modalName, sessionId) {
        this.setState((state, props) => {
            let {showModal, editSessionId} = {...state};
            showModal[modalName] = true;

            editSessionId = sessionId ? sessionId : null;

            return {showModal, editSessionId};
        });
    }

    handleClose(modalName) {
        this.setState((state, props) => {
            const {showModal} = {...state};
            showModal[modalName] = false;
            return {showModal};
        });
    }

    handleRemoveSessionClick(sessionId, event) {
        const callback = () => {
            /* If session has been deleted correctly from the server side then remove it from the session list */
            this.removeSession(sessionId);

            this.handleClose("Delete");
        };

        deleteSession(sessionId, this.props.user.api_token, callback)
    }

    togglePaperSummary(session_id) {
        const {expandPapers} = {...this.state};
        expandPapers[session_id] = !expandPapers[session_id];
        this.setState({expandPapers});
    }

    toggleAllPaperSummaries(value) {
        this.setState((state, props) => {
            const {expandPapers} = {...state};
            for (const sessionId in expandPapers) expandPapers[sessionId] = value;
            return {expandPapers}
        })
    }

    distributeIntoColumns(data) {
        let count = 0;
        let dataColumns = {1: [], 2: [], 3: []};
        const numCols = Object.keys(dataColumns).length;

        for (let x of data) {
            dataColumns[(count % numCols) + 1].push(x);
            count += 1;
        }
        return dataColumns
    }

    createEntryInExpandPapers(session) {
        this.setState((state, props) => {
            const {expandPapers} = {...state};
            const sessionId = session.id;
            if (isPaperSession(session)) expandPapers[sessionId] = true;

            return {expandPapers}
        });
    }

    removeSession(session_id) {
        this.setState((state, props) => {
            const {expandPapers} = {...state};
            delete expandPapers[session_id];

            // Call parent's component
            this.props.removeSession(session_id);

            return {expandPapers}
        });
    }

    render() {
        const {sessionTypes, user, sessionColors} = this.props;
        const {expandPapers, editSessionId} = this.state;

        /* Create column elements */
        let paperSessionColumns = [];
        const paperSessions = this.distributeIntoColumns(filterSessions(this.state.filterText, Object.values(this.props.sessions)));
        for (const column_idx in paperSessions) {
            paperSessionColumns.push(
                <div key={column_idx} className="col-md-4 nostylecol" id={"sessioncol" + column_idx}>
                    {paperSessions[column_idx].map((paperSession) =>
                        <PaperSession key={paperSession.id}
                                      showPapers={expandPapers[paperSession.id]}
                                      paperSession={paperSession}
                                      sessionColor={sessionColors[paperSession.id]}
                                      togglePaperSummary={(e) => this.togglePaperSummary(paperSession.id)}
                                      sessionTypes={sessionTypes}
                                      handleShow={this.handleShow}
                                      user={user}/>
                    )}
                </div>
            )
        }

        /* Only show modal for edition if user has clicked on it */
        let editSessionModal;
        if (this.state.showModal.Edit) {
            const session = this.props.sessions[this.state.editSessionId];
            editSessionModal =
                <EditSessionModal show={this.state.showModal.Edit}
                                  title="Edit Session"
                                  session={session}
                                  handleClose={(e) => this.handleClose("Edit")}
                                  sessionTypes={this.props.sessionTypes}
                                  selectedSessionType="Paper"
                                  user={user}/>
        }

        return (
            <div id="right">
                {/*----- RIGHT NAVBAR HEADER -----*/}
                <div className="filter">
                    <div className="toggler">
                        <a id="expand-all-sessions"
                           alt="expand all"
                           href="#"
                           onClick={(e) => this.toggleAllPaperSummaries(true)}>
                                <span className="pull-right glyphicon glyphicon-zoom-in pointer"
                                      alt="expand all"></span>
                        </a>
                        <a id="collapse-all-sessions"
                           alt="collapse all"
                           href="#"
                           onClick={(e) => this.toggleAllPaperSummaries(false)}>
                                <span className="pull-right glyphicon glyphicon-zoom-out pointer"
                                      alt="collapse all"></span>
                        </a>
                    </div>
                    <h4>Sessions</h4>
                    {/*-- Input for search --*/}
                    <input type="text" value={this.state.filterText} onChange={this.handleChange}
                           className="form-control"
                           placeholder="Filter by name, keyword or track"/>
                    {/*-- Add session modal --*/}
                    {/*-- Trigger the modal with a button --*/}
                    <Button variant="primary" onClick={(e) => this.handleShow("Add")}>
                        Add Session
                    </Button>
                    <AddSessionModal show={this.state.showModal.Add}
                                     title="Add New Session"
                                     handleClose={(e) => this.handleClose("Add")}
                                     onSessionSaved={this.createEntryInExpandPapers}
                                     sessionTypes={this.props.sessionTypes}
                                     selectedSessionType="Paper"
                                     user={user}/>
                    {editSessionModal}
                </div>
                {/*----- RIGHT SCHEDULE -----*/}
                <div className="scrollable row paperstodrag" id="sessionZone">
                    {paperSessionColumns}
                </div>

                {/* Delete modal window */}
                {this.state.showModal.Delete &&
                <DeleteModal show={this.state.showModal.Delete}
                             handleClose={(e) => this.handleClose("Delete")}
                             handleDeleteClick={(e) => this.handleRemoveSessionClick(editSessionId, e)}/>}
            </div>
        )
    }
}

class SessionsPage extends React.Component {
    componentDidMount() {
        this.props.updateHeader("Session Organizer", tabNames.SESSIONS);

        const callback = (result) => {
            /* Store papers in the global state */
            this.props.loadPapers(result.data);
        };

        /* Fetch list of unassigned papers */
        if (!this.props.arePapersLoaded) getUnassignedPapers(this.props.user.api_token, callback)
    }

    render() {
        const {arePapersLoaded, user} = this.props;
        if (!arePapersLoaded) return <Loader/>;
        return (
            <div id="body">
                {/*-----LEFT NAVBAR HEADER -----*/}
                <LeftFrame papers={this.props.papers}/>
                {/*-- end left column -->*/}

                {/*-----RIGHT NAVBAR HEADER -----*/}
                <RightFrame
                    sessionTypes={this.props.sessionTypes}
                    sessions={this.props.sessions}
                    sessionColors={this.props.sessionColors}
                    removeSession={this.props.removeSession}
                    user={user}/>
                {/*-- end right column -->*/}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        papers: state.papers.byIds,
        arePapersLoaded: state.papers.arePapersLoaded,
        sessionColors: state.sessions.sessionColors
    }
};

export default connect(
    mapStateToProps,
    {loadPapers}
)(SessionsPage)
